import { designer } from "@/lib/portfolioData";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer-section"
      className="relative border-t border-black/10 bg-[#f6f3ed]"
    >
      {/* Huge Let's Talk */}
      <a
        href={`mailto:${designer.socials.email}`}
        className="block group"
        data-testid="footer-talk-link"
      >
        <div className="px-6 md:px-10 lg:px-16 py-24 md:py-36">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-black/40">
            Email Mia →
          </p>
        </div>
      </a>

      {/* Bottom rows */}
      <div className="px-6 md:px-10 lg:px-16 py-10 grid grid-cols-1 md:grid-cols-3 gap-6 items-start">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-black/40">
            © {year} Mia Cho Studio
          </p>
          <p className="mt-2 font-display italic text-lg">
            99% Flower, 1% Chaos.
          </p>
        </div>

        <ul className="font-mono text-xs uppercase tracking-[0.22em] space-y-2">
          <li>
            <a
              className="link-underline hover:text-neon-pink transition-colors"
              href={designer.socials.instagram}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
            >
              Instagram ↗
            </a>
          </li>
          <li>
            <a
              className="link-underline hover:text-neon-pink transition-colors"
              href={designer.socials.linkedin}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-linkedin"
            >
              LinkedIn ↗
            </a>
          </li>
          <li>
            <a
              className="link-underline hover:text-neon-pink transition-colors"
              href={`mailto:${designer.socials.email}`}
              data-testid="footer-email"
            >
              {designer.socials.email}
            </a>
          </li>
        </ul>

        <div className="md:text-right font-mono text-[10px] uppercase tracking-[0.22em] text-black/40">
          <a href="#top" className="link-underline" data-testid="footer-back-top">
            Back to top ↑
          </a>
          <p className="mt-2">Designed & dyed by hand · NYC</p>
        </div>
      </div>
    </footer>
  );
}
